export const STATUS_COLORS = {
  new: "bg-[#8c2f1b] text-white",
  contacted: "bg-[#a8842c] text-[#171310]",
  closed: "bg-[#5c5240] text-white",
  pending: "bg-[#8c2f1b] text-white",
  confirmed: "bg-[#3f6b3a] text-white",
  completed: "bg-[#5c5240] text-white",
  cancelled: "bg-[#9c9482] text-white",
};

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const fmtSize = (b) =>
  b > 1024 * 1024 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.round(b / 1024)} KB`;
